import React from "react";
import { useTranslation } from 'react-i18next';

const TextButton = (props) => {
    const {t} = useTranslation();
    return (
        <button 
        className={(props.className || "") + " roundSquare darkBlue"} 
        onClick={(ele) => {props.onClick(ele)}}
        >{t(props.textKey)}</button>
    );
};

export default TextButton;